import { useContext } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { setLikes } from '../redux/reducers/talentSlice'
import { FeathersContext } from '../services/feathers'

// In the case of the reactivation we're pushing a offerId
// In this case we can pass the offerId to the getLikes api call
// And we can modify atlas-search-offer to boost result when offerId == offerId
const useGetLikes = () => {
  const dispatch = useDispatch()
  const feathers = useContext(FeathersContext)
  const { id } = useSelector((state) => state.talent)

  // Fetching likes and setting them in redux
  const { refetch: refetchLikes } = useQuery({
    queryKey: ['likes'],
    queryFn: async () => {
      // Getting all likes from a talent
      // then keeping only those made by the recuiter
      // then formatting them to fit with matching offers
      const likesServer = await feathers.service('lambda-talent').find({
        query: {
          type: 'getLikes',
          talentId: id,
        },
      })
      if (!likesServer.length) {
        dispatch(setLikes({ approved: [], pending: [] }))
        return {}
      }

      const makeLikes = likesServer.reduce(
        (acc, like) => {
          const { candidateStatus } = like
          
          switch (candidateStatus) {
            case 'approved':
              acc.approved.push(like)
              break
            case 'pending':
              acc.pending.push(like)
              break
            default:
              break
          }
          return acc
        },
        {
          approved: [],
          pending: [],
        },
      )

      // Here we can sort to put the ones liked by the recruiter on top (which means they need to be at the end of the array)
      makeLikes.pending.sort((a) => {
        if (a.userStatus === 'approved') {
          return 1
        }
        return -1
      })

      dispatch(setLikes(makeLikes))

      return likesServer
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 3,
    enabled: id?.length > 0,
  })

  return { refetchLikes }
}

export default useGetLikes
